var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "加热直播间",
        width: "602px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "editPeopleNumber overflowOuto",
        },
        [
          _c(
            "div",
            { staticClass: "Viewform" },
            [
              _c("div", { staticClass: "fromLabel" }, [_vm._v("动作")]),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.action,
                    callback: function ($$v) {
                      _vm.action = $$v
                    },
                    expression: "action",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("加热")]),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("恢复")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "Viewform" },
            [
              _c("div", { staticClass: "fromLabel" }, [_vm._v("热度")]),
              _c("el-input", {
                staticStyle: { width: "130px" },
                on: { input: _vm.delNumber },
                model: {
                  value: _vm.value,
                  callback: function ($$v) {
                    _vm.value = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "value",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }